import { Component, Input, OnInit, Output, EventEmitter, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-data-channels-configuration',
  templateUrl: './data-channels-configuration.component.html',
  styleUrls: ['./data-channels-configuration.component.scss']
})
export class DataChannelsConfigurationComponent implements OnInit {

  @Input() accountConfigurationDetails;
  @Output() backEmittor = new EventEmitter<any>();
  @Output() saveEmittor = new EventEmitter<any>();
  @Output() editEmittor = new EventEmitter<any>();
  @Output() editInfoEmittor = new EventEmitter<any>();
  @Output() analyticsEmittor = new EventEmitter<any>();
  selectedGmbAccounts: any;
  selectedAnalyticsAcc: any;
  selectedProperty: any;
  selectedView: any;
  gmbAccounts: any = [];
  analyticsData: any = [];
  analyticsAccount: any = [];
  analyticsPropertise: any = [];
  analyticsViews: any = [];
  accountDetails: any = [];
  accountsInformation: any = [];
  gmbAccountsDetails: any = [];
  saveAnalytics: boolean = false;
  analyticsObject: any = {
    "analytics_info": {
      "account": null,
      "property": null,
      "view": null
    }
  };
  waitTillAccountFetch: boolean = false;
  waitTillPropertiseFetch: boolean = false;
  waitTillViewsFetch: boolean = false;

  ngOnChanges(changes: SimpleChange) {
    this.accountConfigurationDetails = changes['accountConfigurationDetails']['currentValue'];
    if ('analyticsAccount' in this.accountConfigurationDetails) {
      this.analyticsAccount = this.accountConfigurationDetails['analyticsAccount'];
    }
    else if ('analyticsPropertise' in this.accountConfigurationDetails) {
      this.analyticsPropertise = this.accountConfigurationDetails['analyticsPropertise'];
      this.waitTillPropertiseFetch = false;
    }
    else if ('analyticsViews' in this.accountConfigurationDetails) {
      this.analyticsViews = this.accountConfigurationDetails['analyticsViews'];
      this.waitTillViewsFetch = false;
    }
    //console.log(this.accountConfigurationDetails);
  }

  constructor() { }

  ngOnInit(): void {
    if (this.accountConfigurationDetails['type'] == 'gmb') {
      if (this.accountConfigurationDetails['accountDetails']) {
        this.accountDetails = this.accountConfigurationDetails['accountDetails']['locations'];
        for (var i = 0; i < this.accountDetails.length; i++) {
          this.gmbAccountsDetails[i] = this.accountDetails[i];
          this.gmbAccountsDetails[i]['checked'] = false;
        }
        //console.log(this.gmbAccountsDetails);
      }
    }
    if (this.accountConfigurationDetails['type'] == 'analytics') {
      //console.log(this.accountConfigurationDetails);
      if ('analyticsAccount' in this.accountConfigurationDetails) {
        this.analyticsAccount = this.accountConfigurationDetails['analyticsAccount'];
      }
      else if ('analyticsPropertise' in this.accountConfigurationDetails) {
        this.analyticsPropertise = this.accountConfigurationDetails['analyticsPropertise'];
      }
      else if ('analyticsViews' in this.accountConfigurationDetails) {
        this.analyticsViews = this.accountConfigurationDetails['analyticsViews'];
      }
    }
    this.accountsInformation = this.accountConfigurationDetails['accountsInformation'];
  }

  back() {
    this.backEmittor.emit('success');
  }

  selectAccount(event, location, index) {
    if (event.checked == true) {
      this.gmbAccounts.push(
        {
          "locationName": location['title'],
          "name": location['name'],
          "newReviewUrl": location["metadata"]["newReviewUri"]
        }
      );
    }
    if (event.checked == false) {
      this.gmbAccounts.forEach((value, index) => {
        if (value.name == location['name']) this.gmbAccounts.splice(index, 1);
      });
    }
    //console.log(this.gmbAccounts);
  }

  deleteGmbAccount(account, index) {
    this.gmbAccounts.splice(this.gmbAccounts.indexOf(account), 1);
    this.editAccountInformation();
  }

  saveAccount() {
    if (this.accountConfigurationDetails['type'] == 'gmb') {
      let body = {
        "type": 'gmb',
        "gmbData": this.gmbAccounts,
        "gmb_refresh_token": this.accountConfigurationDetails['gmb_refresh_token']
      };
      this.saveEmittor.emit(body);
    }
    else if (this.accountConfigurationDetails['type'] == 'analytics') {
      this.analyticsObject['type'] = "analytics";
      this.analyticsObject['analytics_refresh_token'] = this.accountConfigurationDetails['analyticsRefreshToken'];
      let body = {
        "type": 'analytics',
        "analyticsdata": this.analyticsObject
      };
      this.saveEmittor.emit(body);
    }
  }

  editAccountInformation() {
    let body;
    if (this.accountConfigurationDetails['type'] == 'gmb') {
      body = {
        "type": 'gmb',
        "gmbData": this.gmbAccounts
      };
    }
    else if (this.accountConfigurationDetails['type'] == 'analytics') {
      body = {
        "type": 'analytics',
        "analyticsdata": this.analyticsObject
      };
    }
    this.editInfoEmittor.emit(body);
  }

  addAnotherAccount() {
    this.accountConfigurationDetails['screen'] = "operation";
    this.editEmittor.emit('success');
  }

  close() {
    this.backEmittor.emit('successs');
  }

  analyticsAccountConfiguration(type) {
    if (type == 'propertise') {
      let body = {
        "type": "propertise",
        "endpoint": this.selectedAnalyticsAcc['childLink']['href'],
        "analyticsRefreshToken": this.accountConfigurationDetails['analyticsRefreshToken'],
        "isFirstTime": this.accountConfigurationDetails['isFirstTime'],
        "screen": "operation"
      }
      this.analyticsObject['analytics_info']['account'] = this.selectedAnalyticsAcc['name'] + ' ' + this.selectedAnalyticsAcc['id'];
      this.analyticsEmittor.emit(body);
      this.waitTillPropertiseFetch = true;
    }
    else if (type == 'view') {
      let body = {
        "type": "view",
        "endpoint": this.selectedProperty['childLink']['href'],
        "analyticsRefreshToken": this.accountConfigurationDetails['analyticsRefreshToken'],
        "isFirstTime": this.accountConfigurationDetails['isFirstTime'],
        "screen": "operation"
      }
      this.analyticsObject['analytics_info']['property'] = this.selectedProperty['name'] + ' ' + this.selectedProperty['id'];
      this.analyticsEmittor.emit(body);
      this.waitTillViewsFetch = true;
    }
    else if (type == 'save') {
      //console.log(this.selectedView);
      this.analyticsObject['analytics_info']['view'] = this.selectedView['name'] + ' ' + this.selectedView['id'];
      this.saveAnalytics = true;
    }
    //console.log(this.analyticsObject);
  }
}
